import React, { Component } from 'react';
import { SubmitButton } from '../components/output/Button';
import { HorizontalInput } from '../components/container/LayoutRow';
import './SearchPanelSDS.css';
import SearchPanel from '../components/input/SearchPanel';
import PropTypes from 'prop-types';

class SearchPanelSDS extends Component {
  constructor(props, context) {
    super(props, context);
    const { filters } = props.location.state;
    filters.fullSearch = '';
    this.state = { resource: { ...filters } };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const { history } = this.props;

    history.push({
      pathname: '/substances/searchResult',
      state: this.state.resource
    });
  };

  renderSearchForm = () => {
    const { resource } = this.state;
    return (  
      <HorizontalInput value={resource} style={{ alignItems: 'flex-start' }}>
         <SearchPanel name="substanceCode" label="advancedSearch.code" placeholder="advancedSearch.code"/>
      </HorizontalInput>
    );
  };

  render() {

    return (
      <div className="SearchPanelSDS">
        <form onSubmit={this.handleSubmit}>
          {this.renderSearchForm()}
          <SubmitButton label="general.search" />
        </form>
      </div>
    );
  }

}

SearchPanelSDS.contextTypes = {
  locale: PropTypes.string,
};

export default SearchPanelSDS;



// WEBPACK FOOTER //
// ./src/main/pages/SearchPanelSDS.js